import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";

interface ITitleComboBoxProps {
    titleOptions: LicenceOrganisationRule[];
    title: LicenceOrganisationRule | null;
    onTitleSelect: (title: LicenceOrganisationRule) => void;
    isRequired?: boolean;
    isValid: boolean;
}

function TitleComboBox(props: ITitleComboBoxProps): JSX.Element {
    return (
        <div>
            <select
                id="titleOrganisationSelect"
                onChange={e => props.onTitleSelect(props.titleOptions.find(p => p.Id === e.target.value) ?? null)}
                className={`${props.isValid ? "" : "invalid "}form-control myle-control`}
                value={props.title?.Id ?? ""}
                data-cy="userProfile-practiceTitle"
            >
                <option />
                {props.titleOptions.map(p => (
                    <option
                        key={p.Id}
                        value={p.Id}
                    >
                        {LicenceOrganisationRule.getTitleName(p)}
                    </option>
                ))}
            </select>
        </div>
    );
}

export { TitleComboBox };
